import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnReceipt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M8.71 10.57h7.534M8.709 13.82h5.651M20 7.399v9.203c0 1.409-.128 2.408-.47 3.124 0 0 0 .031-.021.041a.97.97 0 0 1-.8.39c-.502 0-1.1-.326-1.751-1.01-.768-.81-1.964-.757-2.636.137l-.95 1.24c-.374.506-.876.748-1.377.748-.502 0-1.004-.253-1.377-.747l-.929-1.21c-.672-.873-1.868-.957-2.647-.178-1.067 1.135-2.007 1.304-2.551.63 0 0-.021-.031-.021-.041C4.128 19.01 4 18.01 4 16.602V7.398c0-1.409.128-2.408.47-3.123 0 0 0-.021.021-.032.534-.673 1.484-.515 2.551.61.79.789 1.975.705 2.647-.168l.929-1.21c.373-.505.875-.746 1.377-.746.501 0 1.003.252 1.377.746l.95 1.241c.683.884 1.867.947 2.636.137.651-.684 1.249-1.01 1.75-1.01.32 0 .598.137.801.4.021 0 .021.021.021.032.342.715.47 1.714.47 3.123"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnReceipt;
